// Create NEW file: /src/components/admin/BrandList.jsx
// Table component showing all brands

import React from 'react';
import Button from '../common/Button';

const BrandList = ({ brands, onEdit, onDelete }) => {
  return (
    <div className="data-table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th style={{ width: '80px' }}>Logo</th>
            <th>Name (Georgian)</th>
            <th>Name (English)</th>
            <th>Name (Russian)</th>
            <th style={{ width: '100px' }}>Products</th>
            <th style={{ width: '150px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {brands.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center', padding: '3rem' }}>
                <div style={{ color: 'var(--gray)' }}>
                  <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🏷️</div>
                  <p>No brands yet</p>
                  <p style={{ fontSize: '0.9rem' }}>Click "Add Brand" to create your first brand</p>
                </div>
              </td>
            </tr>
          ) : (
            brands.map((brand) => (
              <tr key={brand.id}>
                <td>
                  {brand.logo ? (
                    <img 
                      src={`https://kid-o.ge${brand.logo}`}
                      alt={brand.name || brand.name_ka}
                      style={{ 
                        width: '50px', 
                        height: '50px', 
                        objectFit: 'contain',
                        background: '#f5f5f5',
                        borderRadius: '4px',
                        padding: '4px'
                      }}
                    />
                  ) : (
                    <div style={{ 
                      width: '50px', 
                      height: '50px', 
                      background: '#f5f5f5',
                      borderRadius: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '1.5rem'
                    }}>
                      🏷️
                    </div>
                  )}
                </td>
                <td>
                  <strong>{brand.name_ka || brand.name || '-'}</strong>
                </td>
                <td>{brand.name_en || '-'}</td>
                <td>{brand.name_ru || '-'}</td>
                <td>
                  <span style={{ 
                    background: 'var(--primary-light)', 
                    color: 'var(--primary)',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '12px',
                    fontSize: '0.875rem',
                    fontWeight: '500'
                  }}>
                    {brand.product_count || 0}
                  </span>
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button
                      variant="secondary"
                      size="small"
                      onClick={() => onEdit(brand)}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="danger"
                      size="small"
                      onClick={() => onDelete(brand)}
                      disabled={brand.product_count > 0}
                      title={brand.product_count > 0 ? 'Cannot delete brand with products' : ''}
                    >
                      Delete
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BrandList;